import { useSingleType } from "./content";

/**
 * Textos da página /institucional (single type `sobre`). Ficam no código como
 * padrão: o que estiver preenchido no Strapi sobrescreve, e a tela de edição
 * usa os mesmos valores para pré-preencher os campos.
 */
export const SOBRE_DEFAULTS = {
  eyebrow: "Institucional",
  tituloPagina: "Quem Somos",
  quemSomos: `A Bivver Empreendimentos Imobiliários desenvolve projetos no litoral norte catarinense que unem arquitetura contemporânea, qualidade construtiva e soluções pensadas para o estilo de vida de hoje.

Cada empreendimento nasce da busca por equilíbrio entre localização, funcionalidade, estética e qualidade, criando espaços que façam sentido tanto para quem deseja viver perto do mar quanto para quem busca uma oportunidade de investimento.

Acreditamos que um imóvel representa muito mais do que uma construção. É uma conquista, uma escolha de futuro e o lugar onde histórias acontecem.

Por isso, trabalhamos para transformar projetos em empreendimentos que entreguem valor em cada detalhe — da concepção à entrega e ao relacionamento com nossos clientes.`,
  destaque: "Mais do que construir imóveis.\nCriamos lugares para viver.",
  labelProposito: "Nosso propósito",
  proposito:
    "Desenvolver empreendimentos que conectem pessoas a novos momentos, novas experiências e novas possibilidades de viver e investir.",
  labelMissao: "Nossa missão",
  missao:
    "Desenvolver e entregar empreendimentos imobiliários com qualidade, funcionalidade e identidade, proporcionando segurança, confiança e valor aos nossos clientes.",
  labelVisao: "Nossa visão",
  visao:
    "Ser reconhecida como uma incorporadora de referência no litoral norte catarinense, pela qualidade dos seus empreendimentos, pela confiança nas relações e pela evolução contínua.",
  tituloValores: "Nossos valores",
  valoresLista: [
    {
      titulo: "Credibilidade",
      texto: "Construir relações baseadas na confiança e na responsabilidade.",
    },
    {
      titulo: "Transparência",
      texto: "Comunicar com clareza e agir com honestidade em nossas relações.",
    },
    {
      titulo: "Compromisso",
      texto:
        "Assumir responsabilidades e buscar cumprir aquilo que nos propomos a entregar.",
    },
    {
      titulo: "Qualidade",
      texto:
        "Buscar excelência nos produtos, processos e experiências que oferecemos.",
    },
    {
      titulo: "Foco no cliente",
      texto:
        "Entender necessidades e expectativas para desenvolver soluções que realmente façam sentido.",
    },
    {
      titulo: "Disciplina e organização",
      texto:
        "Trabalhar com método, planejamento e responsabilidade em cada etapa.",
    },
    {
      titulo: "Valorização das pessoas",
      texto: "Reconhecer que bons resultados são construídos por pessoas.",
    },
    {
      titulo: "Trabalho em equipe",
      texto:
        "Unir diferentes conhecimentos e talentos em torno de objetivos comuns.",
    },
  ],
};

export function useSobre() {
  return useSingleType("/sobre", SOBRE_DEFAULTS);
}
